const faq = [
  {
    q: "Wie schnell erhalte ich eine Offerte?",
    a: "In der Regel melden wir uns innerhalb von 24 Stunden nach Eingang Ihrer Anfrage. Bei dringenden Aufträgen kontaktieren Sie uns bitte direkt per Telefon oder WhatsApp – wir versuchen, kurzfristige Termine zu ermöglichen.",
  },
  {
    q: "Haben Sie eine Abnahmegarantie?",
    a: "Ja. Bei unseren Endreinigungen bieten wir eine Abnahmegarantie. Sollte die Reinigung bei der Übergabe nicht akzeptiert werden, kommen wir kostenlos nach und reinigen nach – bis die Abnahme erfolgt ist.",
  },
  {
    q: "Sind Sie versichert?",
    a: "Ja, wir verfügen über eine Betriebs- und Transportversicherung. Sollte während eines Auftrags ein Schaden entstehen, sind Sie und Ihr Eigentum entsprechend abgesichert. Details geben wir gerne auf Anfrage bekannt.",
  },
  {
    q: "Arbeiten Sie auch am Wochenende?",
    a: "Ja, auf Anfrage führen wir Aufträge auch am Wochenende und an Feiertagen durch – ideal für Umzüge, die unter der Woche schwer zu planen sind. Ein kleiner Wochenendzuschlag kann anfallen.",
  },
  {
    q: "Wie erhalte ich eine Offerte?",
    a: "Senden Sie uns Ihre Anfrage über unser Online-Formular, per WhatsApp oder telefonisch mit Angabe von Service, Ort und gewünschtem Zeitraum. Wir melden uns zur Klärung der Details und erstellen danach eine passende Offerte. Eine Anfrage ist noch keine bestätigte Buchung.",
  },
  {
    q: "In welchen Gebieten sind Sie tätig?",
    a: "Unser Schwerpunkt liegt in Zürich und der näheren Region. Wir sind aber in der ganzen Schweiz im Einsatz – teilen Sie uns den genauen Ort mit, damit wir die Verfügbarkeit und den Aufwand prüfen können.",
  },
  {
    q: "Kann ich Fotos mitsenden?",
    a: "Ja, sehr gerne. Fotos helfen uns, Umfang und Zugang besser einzuschätzen und eine genauere Offerte zu erstellen. Bitte senden Sie nur Bilder, die für die Anfrage notwendig sind.",
  },
  {
    q: "Bieten Sie auch Firmenlösungen an?",
    a: "Ja. Anfragen von Büros, Verwaltungen und kleinen Unternehmen sind willkommen. Wir bieten Einzelleistungen sowie regelmässige Services (Hauswartung, Reinigung) mit individuellen Intervallen an.",
  },
  {
    q: "Was kostet eine Besichtigung?",
    a: "Die Besichtigung und die Offerte sind für Sie kostenlos und unverbindlich. So können wir den Umfang realistisch einschätzen und Ihnen einen Fixpreis anbieten.",
  },
];

export default faq;